import { CardsCarousel as HygraphCardsCarouselProps } from '@/lib/types';

import CardsCarousel from '@/components/cards-carousel';

import cardsCarouselTransformer from '@/hygraph/transformers/cards-carousel.transformer';

export default function CardsCarouselRenderer(props: unknown) {
  return (
    <CardsCarousel
      {...cardsCarouselTransformer(props as HygraphCardsCarouselProps)}
    />
  );
}
